import { createContext, useContext } from 'react';

type StepFormContextType = {
  step: number;
  setStep: (step: number) => void;
  setProgressIndicatorVisible: (value: boolean) => void;
  initialStep: number;
};

const stepFormContextDefaultValue = {
  step: 1,
  setStep: () => {},
  setProgressIndicatorVisible: () => {},
  initialStep: 1,
};

const StepFormContext = createContext<StepFormContextType>(
  stepFormContextDefaultValue
);

const StepFormContextProvider = StepFormContext.Provider;

const useStepForm = () => useContext(StepFormContext);

export { useStepForm, StepFormContext, StepFormContextProvider };
